import React from 'react';
import './CoreValues.css';

const CoreValues: React.FC = () => {
  const values = [
    {
      icon: '👥',
      title: 'Experienced Team',
      description: 'Our team of licensed electricians and technicians brings extensive experience and expertise to every project.'
    },
    {
      icon: '⭐',
      title: 'Customer Satisfaction',
      description: 'We prioritize customer satisfaction and strive to build long lasting relationships with our clients based on trust, integrity, and transparency..'
    },
    {
      icon: '💡',
      title: 'Innovative Solutions',
      description: 'We offer innovative solutions to meet the unique needs of each project, ensuring that our clients receive the best possible results.'
    }
  ];

  return (
    <section id="values" className="core-values section-padding">
      <div className="container">
        <div className="section-header text-center mb-8">
          <h2 className="section-title">Why Choose F Square Contracting?</h2>
          <p className="section-subtitle">
            Serving India for over 3 years with unwavering commitment to excellence
          </p>
        </div>
        
        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">{value.icon}</div>
              <h3 className="value-title">{value.title}</h3>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
        </div>
        
        <div className="company-story">
          <div className="story-content">
            <div className="story-text">
              <h3>Our Story</h3>
              <p>
                F Square Contracting has been India's trusted partner 
                for electrical solutions. Founded with a vision to provide 
                reliable, professional services, we have grown from a small local business 
                to a respected name in the industry.
              </p>
              <p>
                Our team of professionals brings years of experience and 
                expertise to every project, whether it's a simple repair or a complex 
                installation. We take pride in our work and stand behind every service 
                we provide.
              </p>
            </div>
            <div className="story-stats">
              <div className="story-stat">
                <span className="story-number">3+</span>
                <span className="story-label">Years in Business</span>
              </div>
              <div className="story-stat">
                <span className="story-number">32+</span>
                <span className="story-label">Projects Completed</span>
              </div>
              <div className="story-stat">
                <span className="story-number">100%</span>
                <span className="story-label">Customer Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
